import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMixDesignIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11.75 1.89545H4.75C4.28587 1.89545 3.84075 2.07245 3.51256 2.38751C3.18437 2.70257 3 3.12988 3 3.57545V17.0154C3 17.461 3.18437 17.8883 3.51256 18.2034C3.84075 18.5184 4.28587 18.6954 4.75 18.6954H15.25C15.7141 18.6954 16.1592 18.5184 16.4874 18.2034C16.8156 17.8883 17 17.461 17 17.0154V6.93545L11.75 1.89545Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4 1.89545V7.49545H17",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2 11.6954H7.19995",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2 14.4955H7.19995",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.59995 7.49545H7.89995H7.19995",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgMixDesignIcon;
